import { formatToTimeAgo } from '@/helpers/date/date';

import * as trackResource from '@/modules/track/track.resource';

export function searchTracks(searchTerm, pagination = {}) {
  return new Promise((resolve, reject) =>
    trackResource
      .searchTracks(searchTerm, pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      }).catch(err => reject(err)));
}

export function fetchTracks(pagination = {}) {
  return new Promise((resolve, reject) =>
    trackResource
      .fetchTracks(pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchTracksAnalytics(payload) {
  return new Promise((resolve, reject) =>
    trackResource
      .fetchTracksAnalytics(payload)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(err => reject(err)));
}

export function fetchUserTracks(user, pagination = {}) {
  return new Promise((resolve, reject) =>
    trackResource
      .fetchUserTracks(user.id, pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchFollowedTracks(user, pagination = {}) {
  return new Promise((resolve, reject) =>
    trackResource
      .fetchFollowedTracks(user, pagination)
      .then(({ data }) => {
        resolve({
          data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function getDepartmentTracks(departmentId) {
  return new Promise((resolve, reject) =>
    trackResource
      .getDepartmentTracks(departmentId)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function getTrackById(id) {
  return new Promise((resolve, reject) =>
    trackResource
      .getTrackById(id)
      .then(({ data }) => {
        resolve({
          data: {
            id: data.id,
            name: data.name,
            slug: data.slug,
            description: data.description,
            number_of_articles: data.number_of_articles,
            total_time: getTotalReadingTime(data.articles),
            deleted: data.deleted,
            updated_at: formatToTimeAgo(data.updated_at),
            department_id: data.department_id,
            access: data.access,
            visits: data.visits,
            user: {
              id: data.user.id,
              name: data.user.name,
              profile_pic: data.user.profile_pic,
              permission: data.user.permission,
            },
            department: data.department,
          },
        });
      })
      .catch(err => reject(err)));
}

// update track's visits (count)
export function updateTrackVisits(track) {
  track.visits++;
  return new Promise((resolve, reject) =>
    trackResource
      .updateTrackVisits(track)
      .then(({ data }) => {
        resolve({
          data,
        });
      }).catch(err => reject(err)));
}

export function saveTrack(track) {
  const payload = prepareTrack(track);
  const errors = validateTrack(track);
  return new Promise((resolve, reject) =>
    (errors ? reject(errors) : getTrackSaveAction(track)(payload)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err))));
}

export function validateTrack(track) {
  let error = null;
  if (!track.articles.length === 0) {
    error = 'Please add some article to your track';
  }
  return error;
}

export function removeTrack(track) {
  return trackResource.removeTrack(track.id);
}

function prepareTrack(track) {
  // TODO: Melhorar iteração ou bolar outra maneira de salvar apenas os IDs
  track.articlesListId = [];
  track.articles.forEach(article => {
    track.articlesListId.push(article.id);
  });

  return {
    id: track.id,
    name: track.name,
    description: track.description,
    department_id: track.department_id,
    access: track.access,
    articles: track.articlesListId,
    number_of_articles: track.articles.length,
  };
}

function getTrackSaveAction(track) {
  return track.id ? trackResource.updateTrack : trackResource.saveNewTrack;
}

// TODO: use getTotalReadingTime function on article.service
function getTotalReadingTime(articles) {
  let total = 0;
  articles.forEach(article => {
    total += article.reading_time;
  });
  return total;
}
